import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface InternalTransferType {
  token: string;
  senderVirtualAccountPrimaryId: number;
  receiverVirtualAccountPrimaryId: number;
  currency: string;
  amount: string;
  remarks: string;
}

export interface InternalTransferTypeResponse {
  paymentRef: string;
}

const internalFundsTransfer = async ({
  token,
  senderVirtualAccountPrimaryId,
  receiverVirtualAccountPrimaryId,
  currency,
  amount,
  remarks,
}: InternalTransferType): Promise<InternalTransferTypeResponse> => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/internal-funds-transfer`,
      {
        senderVirtualAccountPrimaryId,
        receiverVirtualAccountPrimaryId,
        currency,
        amount,
        remarks,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default internalFundsTransfer;
